import { createSelector } from 'reselect';

const selectJobs = (state: any) => state.jobs;

export const selectJobsCurrentItem = createSelector([selectJobs], (jobs) => jobs.current);

export const selectJobsListItems = createSelector([selectJobs], (jobs) => jobs.list);

export const selectJobsItemById = (itemId: any) =>
    createSelector(selectJobsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectJobsCreatedItem = createSelector([selectJobs], (jobs) => jobs.create);

export const selectJobsQueryItems = createSelector([selectJobs], (jobs) => jobs.query);

export const selectJobsUpdatedItem = createSelector([selectJobs], (jobs) => jobs.update);

export const selectReadItem = createSelector([selectJobs], (jobs) => jobs.read);

export const selectJobsDeletedItem = createSelector([selectJobs], (jobs) => jobs.delete);

export const selectJobsSearchedItems = createSelector([selectJobs], (jobs) => jobs.search);

export const selectJobsItemsCount = createSelector([selectJobs], (jobs) => jobs.count);

export const selectJobsItemsFilter = createSelector([selectJobs], (jobs) => jobs.filter);